import React from 'react';
import { FormattedMessage } from 'react-intl';
import { restrictLabel } from './categoriesUtils';
import { Checkbox } from '../../../../components/checkbox/Checkbox';
import { CategoryType } from '../../../search.types';

export function Toggler({
  onToggle,
  isOpen,
}: {
  onToggle: (event: React.MouseEvent<HTMLButtonElement>) => void;
  isOpen: boolean;
}) {
  return (
    <button
      className="search-filters-categories-accordion"
      type="button"
      onClick={onToggle}
    >
      {!isOpen && <OpenLabel />}
      {isOpen && <CloseLabel />}
    </button>
  );
}

export function OpenLabel() {
  return (
    <>
      <i className="material-icons  icons__keyboard_arrow_down search-filters-categories-accordion__icon" />
      <span>
        <FormattedMessage id="search/components/aside-filters/categories/CategoriesLib.tsx/1" />
      </span>
    </>
  );
}

export function CloseLabel() {
  return (
    <>
      <i className="material-icons icons__keyboard_arrow_up search-filters-categories-accordion__icon" />
      <span>
        <FormattedMessage id="search/components/aside-filters/categories/CategoriesLib.tsx/2" />
      </span>
    </>
  );
}

type ItemProps = {
  category: CategoryType;
  children: React.ReactNode;
  handleClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  isSelected: boolean;
};
export function Item({
  category,
  children,
  handleClick,
  isSelected,
}: ItemProps) {
  const isMax = Math.floor(category.count) !== category.count;
  return (
    <>
      <div className="search-filters-checkbox">
        <button
          data-test-id="category-node"
          type="button"
          onClick={handleClick}
          className="search-filters-categories__wrapper"
          title={restrictLabel(category.categoryName)}
        >
          <div className="search-filters-checkbox__wrapper">
            {category.hasSub ? (
              <>
                {isSelected ? (
                  <i className="material-icons icons__arrow_drop_down search-filters-checkbox__arrow" />
                ) : (
                  <i className="material-icons icons__arrow_right search-filters-checkbox__arrow" />
                )}
                <span className="search-filters-checkbox__icon-with-arrow">
                  <Checkbox checked={isSelected} />
                </span>
              </>
            ) : (
              <span className="search-filters-checkbox__icon-no-arrow">
                <Checkbox checked={isSelected} />
              </span>
            )}

            <span className="search-filters-checkbox__label">
              {category.categoryName}
            </span>
          </div>
          <span>{`${Math.floor(category.count)}${
            isMax ? '\u00A0+' : ''
          }`}</span>
        </button>
        {children}
      </div>
    </>
  );
}
